require('./bootstrap');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('bootstrap4-toggle');

import "jquery";
window.$ = window.jQuery = jQuery = $;
import 'datatables';
import 'bootstrap-datepicker';

